import React from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import Dot from './Dot'

const style = theme => ({
    indicatorContainer: {
        position: 'absolute',
        bottom: 16,
        width: '100%',
        display: ({ showIndicators }) => (showIndicators ? 'flex' : 'none'),
        justifyContent: 'center',
        alignItems: 'center',
    },
    indicators: {
        display: 'flex',
    },
})

const Indicators = ({ classes, currentIndex, maxIndex }) => {
    let arr = Array(maxIndex + 1).fill(0)
    return (
        <div className={classes.indicatorContainer}>
            <div className={classes.indicators}>
                {arr.map((_, i, arr) => (
                    <Dot key={i} active={i === currentIndex} />
                ))}
            </div>
        </div>
    )
}

export default compose(injectJss(style))(Indicators)
